import CropIcon from '@src/svgs/CropIcon';
import { observer } from 'mobx-react-lite';
import styled from 'styled-components';

import { useVideoCreatorStore } from '../../stores-v2';

const ReframeVideoIconButton = observer(() => {
  const videoCreator = useVideoCreatorStore();

  const handleClick = () => {
    if (!videoCreator.isVideoCreatorReady) return;
    videoCreator.setOpenReframeVideoModal(true);
  };

  return (
    <Main onClick={handleClick} disabled={!videoCreator.isVideoCreatorReady}>
      <CropIcon fillColor="var(--text-secondary)" />
      Reframe
    </Main>
  );
});

ReframeVideoIconButton.displayName = 'CropVideoIcon';

export default ReframeVideoIconButton;

const Main = styled.div<{ disabled?: boolean }>`
  display: flex;
  align-items: center;
  flex-direction: row;
  position: relative;
  z-index: 10000;
  opacity: ${props => (props.disabled ? 0.7 : 1)};
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  pointer-events: ${props => (props.disabled ? 'none' : 'auto')};
  user-select: none;
  gap: 4px;
  padding: 4px 8px;
  border-radius: var(--radius-button);
  font-family: var(--font-primary);
  font-size: var(--text-xs);
  font-style: normal;
  font-weight: var(--font-weight-medium);
  line-height: normal;
  color: var(--text-secondary);
  background-color: transparent;
  transition: all 150ms ease-out;

  svg path {
    fill: var(--text-secondary);
    transition: fill 150ms ease-out;
  }

  &:hover {
    background-color: var(--surface-elevated);
    color: var(--foreground);

    svg path {
      fill: var(--foreground);
    }
  }

  &:active {
    background-color: var(--gray-700);
    scale: 0.98;
  }
`;
